<template>
    <section v-if="currentSection && showIndicator">
        <div v-if="compact" class="container compact-step-indicator">
            <div class="row">
                <div class="col-12 text-center d-flex justify-content-center">
                    <p class="step-counter d-flex flex-shrink-1">
                        <span class="darken">{{ currentSectionNumber }}</span
                        ><span class="total-sections">/ {{ sectionCount }}</span>
                    </p>
                    <span class="vertical-line d-flex flex-shrink-1 align-self-center"></span>
                    <h2 class="step-title d-flex flex-shrink-1">{{ currentSection.name }}</h2>
                </div>
            </div>
        </div>

        <div v-else class="container step-indicator">
            <div class="row">
                <div class="col-12 d-flex justify-content-center">
                    <div class="step-block d-flex flex-shrink-0" v-for="index in sectionCount" :key="index">
                        <div v-if="isCompleted(index)" class="step-circle d-flex completed">
                            <div class="circle-inner d-flex">
                                <i class="far fa-check"></i>
                            </div>
                        </div>

                        <div v-else-if="isCurrent(index)" class="d-flex">
                            <div class="step-circle d-flex current">
                                <div class="circle-inner d-flex flex-shrink-0">
                                    <span>{{ index }}</span>
                                </div>
                            </div>
                            <h2>{{ currentSection.name }}</h2>
                        </div>

                        <div v-else class="step-circle d-flex incomplete">
                            <div class="circle-inner d-flex">
                                <span>{{ index }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { useStore, mapGetters } from 'vuex'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    props: {
        compact: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['currentSection', 'sectionCount']),
        currentSectionNumber() {
            return this.currentSection.index + 1
        },
        showIndicator: function () {
            return parseInt(this.themeSetting('hide_section_heading_numbers')) !== 1
        },
    },
    methods: {
        isCompleted: function (index) {
            return index < this.currentSectionNumber
        },
        isCurrent: function (index) {
            return this.currentSectionNumber === index
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.step-indicator {
    .step-block {
        border-right: 1px solid #e0e1e5;
        padding: 0px 14px;

        &:last-child {
            border: none;
        }

        h2 {
            align-self: center;
            color: var(--wizard-header-step-counter-text-color);
            font-size: rem(18px);
            font-weight: 700;
            margin: 0px 0px 0px 7px;
        }
    }

    .step-circle {
        border-radius: 50%;
        height: 38px;
        min-width: 38px;
        padding: 2px;

        .circle-inner {
            align-items: center;
            border-radius: 50%;
            justify-content: center;
            min-height: 100%;
            min-width: 100%;
            color: var(--wizard-header-step-counter-text-color);
            .fa-check {
                color: #ffffff;
            }
        }

        &.completed,
        &.current {
            border: 1px solid var(--wizard-step-indicator-circle-color);

            .circle-inner {
                background-color: var(--wizard-step-indicator-circle-color);
                color: #ffffff;
            }
        }

        &.incomplete {
            border: 1.2px solid #e0e1e5;
            color: #e0e1e5;
        }
    }
}

.compact-step-indicator {
    margin-top: 25px;

    .step-counter {
        color: var(--wizard-step-header-color);
        font-family: var(--primary-font);
        font-size: rem(24px);
        font-weight: 700;
        letter-spacing: 1px;
        line-height: 20px;
        margin: auto 0px;

        .darken {
            filter: brightness(60%);
        }

        .total-sections {
            color: var(--wizard-step-header-color);
            font-size: rem(12px);
            letter-spacing: -1px;
            line-height: 14px;
            margin: auto 0px 0px;
        }
    }

    .step-title {
        color: var(--wizard-step-header-color);
        font-family: var(--primary-font);
        font-size: rem(13px);
        font-weight: 600;
        margin: auto 0px;
        text-transform: uppercase;
    }

    .vertical-line {
        border-left: 2px solid #e1e5ef;
        height: 22px;
        margin: 10px;
    }
}
</style>
